var _a;
import * as React from 'react';
import { positiveIcon, neutralIcon, negativeIcon, csatSubmittedIcon } from './icons';
import { SatisfactionRatingType } from '@wix/answers-api';
import { Button, Icon, TextArea } from '@wix/answers-ui-libby';
import { compKey } from './key';
import { classNames } from '@wix/answers-lib';
export var satisfactionIconMap = (_a = {},
    _a[SatisfactionRatingType.POSITIVE] = positiveIcon,
    _a[SatisfactionRatingType.NEUTRAL] = neutralIcon,
    _a[SatisfactionRatingType.NEGATIVE] = negativeIcon,
    _a);
var getOptionClassName = function (option, selected) {
    return "satisfaction-option satisfaction-" + option + " " + (selected ? 'selected' : '');
};
export var CsatSurveyView = function (props) {
    var selectOption = function (option) { return function () { return props.onSelectOption(option); }; };
    var onChangeUserComment = function (comment) { return props.setUserComment(comment.substr(0, props.maxUserCommentLength)); };
    var renderSatisfactionOption = function (option) {
        var isOptionSelected = option === props.selectedOption;
        return (React.createElement("button", { className: getOptionClassName(option, isOptionSelected), onClick: selectOption(option), "aria-label": props.t("satisfaction-option-" + option + ".aria-label"), role: 'radio', "aria-checked": isOptionSelected },
            React.createElement(Icon, { className: isOptionSelected ? 'selected' : '', icon: satisfactionIconMap[option] })));
    };
    var maybeResponseMessage = props.responseMessage ? (React.createElement("div", { className: 'user-comment-response-message' }, props.responseMessage)) : null;
    var maybeFollowUpMessage = props.followUpMessage ? (React.createElement("div", { className: 'user-comment-follow-up-message' }, props.followUpMessage)) : null;
    var maybeUserCommentMessages = maybeFollowUpMessage || maybeResponseMessage ? (React.createElement("div", { className: 'user-comment-messages-wrapper' },
        maybeResponseMessage,
        maybeFollowUpMessage)) : null;
    var maybeCommentBox = props.selectedOption && props.customerCommentEnabled ? (React.createElement("div", { className: 'user-comment-wrapper' },
        React.createElement("label", null,
            maybeUserCommentMessages,
            React.createElement(TextArea, { className: 'user-comment-textarea', value: props.userComment, onChange: onChangeUserComment, placeholder: props.t('user-comment-placeholder') })),
        React.createElement("div", { className: 'comment-length-counter' },
            props.userComment.length,
            "/",
            props.maxUserCommentLength))) : null;
    var maybeSubmitButton = props.selectedOption && (React.createElement("div", { className: 'submit-form-wrapper' },
        maybeCommentBox,
        React.createElement("div", { className: 'submit-button-wrapper' },
            React.createElement(Button, { onClick: props.onSubmit, className: 'submit-button' }, props.t('submit-survey')))));
    var visibleRatingTypes = [
        SatisfactionRatingType.NEGATIVE,
        SatisfactionRatingType.NEUTRAL,
        SatisfactionRatingType.POSITIVE,
    ].filter(function (satisfactionType) { return !(props.hiddenRatingTypes || []).includes(satisfactionType); });
    var maybeThankYouMessage = props.automaticSubmissionMode ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "automatic-submission-message" },
            React.createElement(Icon, { icon: csatSubmittedIcon }),
            React.createElement("div", { className: 'automatic-submission-title' }, props.thankYouMessage)),
        React.createElement("div", { className: 'automatic-submission-message-divider' }))) : null;
    var className = classNames(compKey, {
        'auto-submit-mode': props.automaticSubmissionMode
    });
    return (React.createElement("div", { className: className },
        maybeThankYouMessage,
        React.createElement("div", { className: 'survey-title-wrapper', "data-hook": 'survey-title' },
            React.createElement("div", { className: 'survey-title' }, props.ratingRequestMessage)),
        React.createElement("div", { className: 'satisfaction-options-wrapper', role: 'radiogroup' }, visibleRatingTypes.map(renderSatisfactionOption)),
        maybeSubmitButton));
};
//# sourceMappingURL=index.js.map